// its base code dont change this

// import "../selectdata.css";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom"; // ✅ Added useNavigate
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// const UaerTabel = () => {
//   const [responseData, setResponseData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [recordsPerPage, setRecordsPerPage] = useState(10);

//   const navigate = useNavigate(); // ✅ Added navigate hook

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     applyFilter(searchQuery);
//   }, [responseData, searchQuery]);

//   const fetchData = async () => {
//     setError(null);
//     setLoading(true);
//     setResponseData([]);

//     const data = new URLSearchParams();
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "users");
//     data.append("WhereCondition", "All");
//     data.append("*", "*");

//     try {
//       const response = await fetch(
//         "https://etour.responseinfoway.com/restapi/Selectdata.aspx",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//           },
//           body: data.toString(),
//         }
//       );

//       if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

//       const jsonData = await response.json();
//       console.log("Fetched Response Data:", jsonData);

//       if (jsonData.Response) {
//         setResponseData(jsonData.Response);
//         setFilteredData(jsonData.Response);
//       } else {
//         setError("No data found.");
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const applyFilter = (query) => {
//     if (!query) {
//       setFilteredData(responseData);
//     } else {
//       const lowerQuery = query.toLowerCase();
//       const filtered = responseData.filter((item) =>
//         Object.values(item).some(
//           (value) =>
//             value && value.toString().toLowerCase().includes(lowerQuery)
//         )
//       );
//       setFilteredData(filtered);
//     }
//     setCurrentPage(1);
//   };

//   const handleDelete = async (id) => {
//   console.log("Delete button clicked for ID:", id);

//   if (!window.confirm("Are you sure you want to delete this user?")) return;

//   const deleteParams = new URLSearchParams();
//   deleteParams.append("SecurityKey", SECURITY_KEY);
//   deleteParams.append("TableName", "users");
//   deleteParams.append("WhereCondition", `ID=${id}`);

//   try {
//     const response = await fetch(
//       "https://etour.responseinfoway.com/restapi/deletedata.aspx",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: deleteParams.toString(),
//       }
//     );

//     const result = await response.json(); // Parse JSON
//     console.log("Delete API parsed response:", result);

//     if (
//       result?.Response &&
//       Array.isArray(result.Response) &&
//       result.Response[0]?.Status?.toLowerCase() === "ok"
//     ) {
//       // ✅ Instantly remove deleted item from table state
//       setResponseData((prevData) =>
//         prevData.filter((item) => String(item.ID) !== String(id))
//       );
//       setFilteredData((prevData) =>
//         prevData.filter((item) => String(item.ID) !== String(id))
//       );

//       toast.success("Data deleted successfully!", {
//         position: "top-center",
//         autoClose: 2000,
//       });
//     } else {
//       toast.error("Failed to delete user!", {
//         position: "top-center",
//         autoClose: 2000,
//       });
//     }
//   } catch (err) {
//     console.error("Delete error:", err);
//     toast.error("Error deleting user.", {
//       position: "top-center",
//       autoClose: 2000,
//     });
//   }
// };

//   const lastIndex = currentPage * recordsPerPage;
//   const firstIndex = lastIndex - recordsPerPage;
//   const currentRecords = filteredData.slice(firstIndex, lastIndex);
//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);

//   return (
// <div className="masdata_container">
//   {loading && <p className="loading-message">Loading data...</p>}
//   {error && <p className="error-message">{error}</p>}

//   <div className="Payment_div">
//     <div className="payment_maintext">
//       <h6>Users</h6>
//       <div>
//         <Link className="payment_breadcrumbs" to={"/selectdata"}>
//           <p>Master</p>
//         </Link>
//         <span>
//           <i className="fa-solid fa-chevron-right"></i>Users
//         </span>
//       </div>
//     </div>
//         <div className="button_search-payment">
//           <Link to={"/newusers"}>
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add New Users
//             </button>
//           </Link>
//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for name or designation..."
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>
//       </div>

//       {!loading && filteredData.length === 0 && !error && (
//         <p className="no-data-message">No data available.</p>
//       )}

//       {filteredData.length > 0 && (
//         <div className="response-container-user">
//           <div className="table-wrapper">
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Login Id</th>
//                   <th>Password</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {currentRecords.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.LoginID}</td>
//                     <td>{item.Password}</td>
//                     <td>
//                       <Link to="/Updateuser" state={{ responseData: item }}>
//                         <button className="selet_edit-btn" title="Edit">
//                           <i className="fa-solid fa-pen-to-square"></i>
//                         </button>
//                       </Link>
//                       <button
//                         className="select_delete-btn"
//                         title="Delete"
//                         onClick={() => handleDelete(item.ID)}
//                         style={{
//                           marginLeft: "10px",
//                           background: "transparent",
//                           border: "none",
//                           cursor: "pointer",
//                           padding: "4px",
//                           color: "red",
//                         }}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination Controls */}
//           <div className="select_pagination mt-4">
//             <button
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
//             <span>
//               &nbsp; {currentPage} of {totalPages}
//             </span>
//             <button
//               onClick={() =>
//                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//               }
//               disabled={currentPage === totalPages}
//             >
//               &nbsp; Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Toast Notifications */}
//       <ToastContainer position="top-center" autoClose={2000} />
//     </div>
//   );
// };

// export default UaerTabel;

// here show the all details of table update after

// import "../selectdata.css";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// const UaerTabel = () => {
//   const [responseData, setResponseData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [recordsPerPage, setRecordsPerPage] = useState(10);
//   const [deleteId, setDeleteId] = useState(null);

//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchData(); // Fetch users
//   }, []);

//   useEffect(() => {
//     applyFilter(searchQuery);
//   }, [responseData, searchQuery]);

//   /** Fetch Users */
//   const fetchData = async () => {
//     setError(null);
//     setLoading(true);
//     setResponseData([]);

//     const data = new URLSearchParams();
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "Users");
//     data.append("WhereCondition", "All");
//     data.append("*", "*");

//     try {
//       const response = await fetch("http://localhost:5000/api/user?CompId=${loggedInCompanyId}", {
//         method: "GET",
//         headers: { "Content-Type": "application/json" },
//       });

//       if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);
//       const jsonData = await response.json();
//       if (jsonData && Array.isArray(jsonData)) {
//         setResponseData(jsonData);
//         setFilteredData(jsonData);
//       } else {
//         setError("No data found.");
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** Apply search filter and sort by Created_On ascending (oldest first) */
//   const applyFilter = (query) => {
//     let dataToFilter = [...responseData];

//     if (query) {
//       const lowerQuery = query.toLowerCase();
//       dataToFilter = dataToFilter.filter((item) =>
//         Object.values(item).some(
//           (value) =>
//             value && value.toString().toLowerCase().includes(lowerQuery)
//         )
//       );
//     }

//     // Sort by Created_On ascending (oldest first)
//     dataToFilter.sort((a, b) => {
//       const dateA = new Date(a.Created_On);
//       const dateB = new Date(b.Created_On);
//       return dateA - dateB;
//     });

//     setFilteredData(dataToFilter);
//     setCurrentPage(1);
//   };

//   /** Edit User */
//   const handleEdit = (item) => {
//     navigate("/Updateuser", { state: { responseData: item } });
//   };

//   /** Delete User */
//   const handleDelete = async () => {
//     if (!deleteId) return;

//     const deleteParams = new URLSearchParams();
//     deleteParams.append("SecurityKey", SECURITY_KEY);
//     deleteParams.append("TableName", "Users");
//     deleteParams.append("WhereCondition", `ID=${deleteId}`);

//     try {
//       const response = await fetch(`http://localhost:5000/api/user/${deleteId}`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//       });

//       const resultText = await response.text();
//       console.log("Delete response:", resultText);

//       let result;
//       try {
//         result = JSON.parse(resultText);
//       } catch (e) {
//         result = {};
//       }

//       if (
//         result?.message?.toLowerCase().includes("success") ||
//         result?.status?.toLowerCase() === "ok"
//       ) {
//         setResponseData((prevData) =>
//           prevData.filter((item) => String(item.ID) !== String(deleteId))
//         );
//         setFilteredData((prevData) =>
//           prevData.filter((item) => String(item.ID) !== String(deleteId))
//         );

//         toast.success("User deleted successfully!");
//       } else {
//         toast.error("Failed to delete user!");
//       }
//     } catch (err) {
//       console.error("Delete error:", err);
//       toast.error("Error deleting user.");
//     } finally {
//       setDeleteId(null);
//     }
//   };

//   /** Pagination Calculations */
//   const lastIndex = currentPage * recordsPerPage;
//   const firstIndex = lastIndex - recordsPerPage;
//   const currentRecords = filteredData.slice(firstIndex, lastIndex);
//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);

//   return (
//     <div className="masdata_container">
//       {loading && <p className="loading-message">Loading data...</p>}
//       {error && <p className="error-message">{error}</p>}

//       <div className="Payment_div">
//         <div className="payment_maintext">
//           <h6>Users</h6>
//           <div>
//             <Link className="payment_breadcrumbs" to="/selectdata">
//               <p>Master</p>
//             </Link>
//             <span>
//               <i className="fa-solid fa-chevron-right"></i> Users
//             </span>
//           </div>
//         </div>

//         <div className="button_search-payment">
//           <Link to="/newusers">
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add New Users
//             </button>
//           </Link>

//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for name or designation..."
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {!loading && filteredData.length === 0 && !error && (
//           <p className="no-data-message">No data available.</p>
//         )}

//         {filteredData.length > 0 && (
//           <div className="response-container-user">
//             <div className="table-wrapper">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th className="w-16 text-center">Sl. No</th>
//                     <th>Company Name</th>
//                     <th>Login Id</th>
//                     <th>Password</th>
//                     <th className="w-14">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentRecords.map((item, index) => (
//                     <tr key={item.ID}>
//                       <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
//                       <td>{item.CompanyName || "-"}</td>
//                       <td>{item.LoginID}</td>
//                       <td>{item.Password}</td>
//                       <td>
//                         <div className="seletdata_edit-delet-btn">
//                           <button
//                             className="selet_edit-btn"
//                             title="Edit"
//                             onClick={() => handleEdit(item)}
//                           >
//                             <i className="fa-solid fa-pen-to-square"></i>
//                           </button>
//                           <button
//                             className="select_delete-btn"
//                             title="Delete"
//                             data-bs-toggle="modal"
//                             data-bs-target="#deleteConfirmationModal"
//                             onClick={() => setDeleteId(item.ID)}
//                           >
//                             <i className="fa-solid fa-trash"></i>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="select_pagination mt-4">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>
//               <span>
//                 &nbsp; {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() =>
//                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//               >
//                 &nbsp; Next
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="modal fade" id="deleteConfirmationModal">
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="close_topbutton-taxes">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//               ></button>
//             </div>
//             <div className="delet_icon-boxtaxes">
//               <i className="fa-solid fa-trash"></i>
//             </div>
//             <div className="taxes_pcolom">
//               <h6>Confirm Delete</h6>
//               <p>Are you sure you want to delete this user?</p>
//             </div>
//             <div className="close_bottombutton-taxes">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="delete_button"
//                 data-bs-dismiss="modal"
//                 onClick={handleDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <ToastContainer position="top-center" autoClose={2000} />
//     </div>
//   );
// };

// export default UaerTabel;

// dont delete it

// import "../selectdata.css";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// const UaerTabel = () => {
//   const [responseData, setResponseData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [recordsPerPage, setRecordsPerPage] = useState(10); // default 10
//   const [deleteId, setDeleteId] = useState(null);
//   const [userId, setUserId] = useState(null);

//   const navigate = useNavigate();

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   useEffect(() => {
//     setUserId(localStorage.getItem("userId"));
//   }, []);

//   useEffect(() => {
//     if (userId) fetchUserAcctoCompany(userId);
//   }, [userId]);

//   useEffect(() => {
//     applyFilter(searchQuery);
//   }, [responseData, searchQuery]);

//   /** Fetch Users */
//   const fetchUserAcctoCompany = async (masterId) => {
//     setError(null);
//     setLoading(true);
//     setResponseData([]);

//     try {
//       // const response = await fetch(`http://localhost:5000/api/user?masterId=${masterId}`, {
//       // const response = await fetch(`https://etour.responseinfoway.com/api/user?masterId=${masterId}`, {
//       const response = await fetch(`${BASE_API_URL}/user?masterId=${masterId}`, {
//         method: "GET",
//         headers: { "Content-Type": "application/json" },
//       });

//       if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);
//       const jsonData = await response.json();

//       if (jsonData && Array.isArray(jsonData?.data)) {
//         setResponseData(jsonData?.data);
//         setFilteredData(jsonData?.data);
//       } else {
//         setError("No data found.");
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** Apply search filter and sort by Created_On ascending */
//   const applyFilter = (query) => {
//     let dataToFilter = [...responseData];

//     if (query) {
//       const lowerQuery = query.toLowerCase();
//       dataToFilter = dataToFilter.filter((item) =>
//         Object.values(item).some(
//           (value) => value && value.toString().toLowerCase().includes(lowerQuery)
//         )
//       );
//     }

//     // Sort by Created_On if exists
//     dataToFilter.sort((a, b) => {
//       if (a.Created_On && b.Created_On) {
//         return new Date(a.Created_On) - new Date(b.Created_On);
//       }
//       return 0;
//     });

//     setFilteredData(dataToFilter);
//     setCurrentPage(1);
//   };

//   /** Edit User */
//   const handleEdit = (item) => {
//     navigate("/Updateuser", { state: { responseData: item } });
//   };

//   /** Delete User */
//   const handleDelete = async () => {
//     if (!deleteId) return;

//     try {
//       // const response = await fetch(`http://localhost:5000/api/user/${deleteId}`, {
//       // const response = await fetch(`https://etour.responseinfoway.com/api/user/${deleteId}`, {
//       const response = await fetch(`${BASE_API_URL}/user/${deleteId}`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//       });

//       const resultText = await response.text();
//       console.log("Delete response:", resultText);

//       let result;
//       try {
//         result = JSON.parse(resultText);
//       } catch (e) {
//         result = {};
//       }

//       if (
//         result?.message?.toLowerCase().includes("success") ||
//         result?.status?.toLowerCase() === "ok"
//       ) {
//         setResponseData((prevData) =>
//           prevData.filter((item) => String(item.ID) !== String(deleteId))
//         );
//         setFilteredData((prevData) =>
//           prevData.filter((item) => String(item.ID) !== String(deleteId))
//         );

//         toast.success("User deleted successfully!");
//       } else {
//         toast.error("Failed to delete user!");
//       }
//     } catch (err) {
//       console.error("Delete error:", err);
//       toast.error("Error deleting user.");
//     } finally {
//       setDeleteId(null);
//     }
//   };

//   /** Pagination Calculations */
//   const lastIndex = currentPage * recordsPerPage;
//   const firstIndex = lastIndex - recordsPerPage;
//   const currentRecords = filteredData.slice(firstIndex, lastIndex);
//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);

//   return (
//     <div className="masdata_container">
//       {loading && <p className="loading-message">Loading data...</p>}
//       {error && <p className="error-message">{error}</p>}

//       <div className="Payment_div">
//         <div className="payment_maintext">
//           <h6>Users</h6>
//           <div>
//             <Link className="payment_breadcrumbs" to="/selectdata">
//               <p>Master</p>
//             </Link>
//             <span>
//               <i className="fa-solid fa-chevron-right"></i> Users
//             </span>
//           </div>
//         </div>

//         <div className="button_search-payment">
//           <div style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "column", alignItems: "flex-start" }}>
//             <Link to="/newusers">
//               <button type="button" className="btn btn">
//                 <i className="fa-solid fa-plus"></i> Add New Users
//               </button>
//             </Link>

//             {/* Records Per Page dropdown under Add New Users */}
//             <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "14px" }}>
//               <label htmlFor="recordsPerPage">Records Per Page :</label>
//               <select
//                 id="recordsPerPage"
//                 value={recordsPerPage}
//                 onChange={(e) => setRecordsPerPage(Number(e.target.value))}
//                 style={{ height: "28px", fontSize: "11px" }}
//               >
//                 <option value={5}>5</option>
//                 <option value={10}>10</option>
//                 <option value={15}>15</option>
//                 <option value={20}>20</option>
//               </select>
//             </div>
//           </div>

//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for name or designation..."
//               onChange={(e) => setSearchQuery(e.target.value)}
//               style={{ height: "28px", fontSize: "11px" }}
//             />
//           </div>
//         </div>

//         {!loading && filteredData.length === 0 && !error && (
//           <p className="no-data-message">No data available.</p>
//         )}

//         {filteredData.length > 0 && (
//           <div className="response-container-user">
//             <div className="table-wrapper">
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th className="w-16 text-center">Sl. No</th>
//                     <th>Company Name</th>
//                     <th>Login Id</th>
//                     <th>Password</th>
//                     <th className="w-14">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentRecords.map((item, index) => (
//                     <tr key={item.ID}>
//                       <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
//                       <td>{item.CompanyName || "-"}</td>
//                       <td>{item.LoginID}</td>
//                       <td>{item.Password}</td>
//                       <td>
//                         <div className="seletdata_edit-delet-btn">
//                           <button
//                             className="selet_edit-btn"
//                             title="Edit"
//                             onClick={() => handleEdit(item)}
//                           >
//                             <i className="fa-solid fa-pen-to-square"></i>
//                           </button>
//                           <button
//                             className="select_delete-btn"
//                             title="Delete"
//                             data-bs-toggle="modal"
//                             data-bs-target="#deleteConfirmationModal"
//                             onClick={() => setDeleteId(item.ID)}
//                           >
//                             <i className="fa-solid fa-trash"></i>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="select_pagination mt-4">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>
//               <span>
//                 &nbsp; {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() =>
//                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//               >
//                 &nbsp; Next
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Delete Confirmation Modal */}
//       <div className="modal fade" id="deleteConfirmationModal">
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="close_topbutton-taxes">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//               ></button>
//             </div>
//             <div className="delet_icon-boxtaxes">
//               <i className="fa-solid fa-trash"></i>
//             </div>
//             <div className="taxes_pcolom">
//               <h6>Confirm Delete</h6>
//               <p>Are you sure you want to delete this user?</p>
//             </div>
//             <div className="close_bottombutton-taxes">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="delete_button"
//                 data-bs-dismiss="modal"
//                 onClick={handleDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <ToastContainer position="top-center" autoClose={2000} />
//     </div>
//   );
// };

// export default UaerTabel;

// its working now here phase the user by the company select

import "../Ledger/ShowLedger.css";
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { apiWithLog } from "../../../utils/apiWithLog";
import DeleteConfirmModal from "../../../Component/DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../../../Component/Skeleton";


const UaerTabel = () => {
  const [responseData, setResponseData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const togglePasswordVisibility = (id) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // ✅ ADDED — store current CompID
  const [currentCompId, setCurrentCompId] = useState(null);

  // ✅ ADDED — ref to track previous CompID
  const prevCompIdRef = useRef(null);

  const navigate = useNavigate();
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // --------------------------------------------------
  // ✅ FETCH USERS COMPANY-WISE (UNCHANGED LOGIC)
  // --------------------------------------------------
  const fetchUserAcctoCompany = async (compId) => {
    if (!compId) return;

    setError(null);
    setLoading(true);
    setResponseData([]);

    try {
      const response = await fetch(`${BASE_API_URL}/user/users/${compId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const jsonData = await response.json();

      if (jsonData && Array.isArray(jsonData.data)) {
        setResponseData(jsonData.data);
        setFilteredData(jsonData.data);
      } else {
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch users.");
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // 🔥 CORE LOGIC — AUTO UPDATE USERS WHEN COMPANY CHANGES
  // --------------------------------------------------
  useEffect(() => {
    const interval = setInterval(() => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      const newCompId = company?.id || null;

      // 🔥 Detect company change
      if (newCompId && prevCompIdRef.current !== newCompId) {
        prevCompIdRef.current = newCompId;
        setCurrentCompId(newCompId);
        fetchUserAcctoCompany(newCompId);
      }
    }, 300); // lightweight & safe

    return () => clearInterval(interval);
  }, []);

  /** Delete User */
  // const handleDelete = async () => {
  //   if (!deleteId) return;

  //   try {
  //     // const response = await fetch(`http://localhost:5000/api/user/${deleteId}`, {
  //     // const response = await fetch(`https://etour.responseinfoway.com/api/user/${deleteId}`, {
  //     const response = await fetch(`${BASE_API_URL}/user/${deleteId}`, {
  //       method: "DELETE",
  //       headers: { "Content-Type": "application/json" },
  //     });

  //     const resultText = await response.text();
  //     console.log("Delete response:", resultText);

  //     let result;
  //     try {
  //       result = JSON.parse(resultText);
  //     } catch (e) {
  //       result = {};
  //     }

  //     if (
  //       result?.message?.toLowerCase().includes("success") ||
  //       result?.status?.toLowerCase() === "ok"
  //     ) {
  //       setResponseData((prevData) =>
  //         prevData.filter((item) => String(item.ID) !== String(deleteId))
  //       );
  //       setFilteredData((prevData) =>
  //         prevData.filter((item) => String(item.ID) !== String(deleteId))
  //       );

  //       toast.success("User deleted successfully!");
  //     } else {
  //       toast.error("Failed to delete user!");
  //     }
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //     toast.error("Error deleting user.");
  //   } finally {
  //     setDeleteId(null);
  //   }
  // };



  const handleDelete = async () => {
    if (isDeleting) return;
    if (!deleteId) return;

    try {
      setIsDeleting(true);

    // ============================
    // DELETE with Logging
    // ============================
    const res = await apiWithLog({
      method: "DELETE",
      url: `${BASE_API_URL}/user/${deleteId}`,
      module: "User",
      action: "D",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Handle text or JSON response
    let result = res.data || res;

    if (typeof result === "string") {
      try {
        result = JSON.parse(result);
      } catch {
        result = {};
      }
    }

    console.log("Delete response:", result);

    // ============================
    // Success Check
    // ============================
    if (
      result?.message?.toLowerCase().includes("success") ||
      result?.status?.toLowerCase() === "ok" ||
      result?.success === true
    ) {
      // Update UI without reload
      setResponseData((prevData) =>
        prevData.filter((item) => String(item.ID) !== String(deleteId))
      );

      setFilteredData((prevData) =>
        prevData.filter((item) => String(item.ID) !== String(deleteId))
      );

      showToast.delete("User deleted successfully!");
      setDeleteModalOpen(false);
    } else {
      showToast.error("Failed to delete user!");
    }
  } catch (error) {
    console.error("Delete error:", error);

    if (error?.response?.data?.message) {
      showToast.error(error.response.data.message);
    } else {
      showToast.error("Error deleting user.");
    }
  } finally {
    setIsDeleting(false);
    setDeleteId(null);
  }
};



  // --------------------------------------------------
  // SEARCH FILTER (UNCHANGED)
  // --------------------------------------------------
  useEffect(() => {
    let dataToFilter = [...responseData];

    if (searchQuery) {
      const lowerQuery = searchQuery.toLowerCase();
      dataToFilter = dataToFilter.filter((item) =>
        Object.values(item).some(
          (value) =>
            value && value.toString().toLowerCase().includes(lowerQuery)
        )
      );
    }

    setFilteredData(dataToFilter);
    setCurrentPage(1);
  }, [searchQuery, responseData]);

  const handleEdit = (item) => {
    navigate("/Updateuser", { state: { responseData: item } });
  };

  // --------------------------------------------------
  // PAGINATION
  // --------------------------------------------------
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentRecords = filteredData.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  return (
    <div className="ledger_page_container">
      {/* TOP HEADER & BREADCRUMBS */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h4 className="ledger_header_title">User Master</h4>
          <div className="ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <span>Master</span>
            <span>/</span>
            <span>Users</span>
          </div>
        </div>
      </div>

      {/* TOP CONTROLS CARD */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <Link to="/newusers" className="new_ledger_btn">
            + Add User
          </Link>
        </div>

        <div className="ledger_top_right">
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search users..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={7} rows={6} hasToolbar={false} />
        )}

        {error && !loading && (
          <div className="ledger_empty_state">
            <h6>Error Loading Data</h6>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && filteredData.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    <th style={{ width: "60px", textAlign: "center" }}>Sl. No</th>
                    <th>Company Name</th>
                    <th>Login Id</th>
                    <th style={{ width: "190px", minWidth: "190px" }}>Password</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((item, index) => (
                    <tr key={item.ID}>
                      <td style={{ textAlign: "center", color: "#64748b" }}>
                        {(currentPage - 1) * recordsPerPage + index + 1}
                      </td>
                      <td className="ledger_name_cell">{item.CompanyName || "-"}</td>
                      <td>{item.LoginID}</td>
                      <td style={{ width: "190px", minWidth: "190px" }}>
                        {item.Password ? (
                          <div className="password_display_wrapper">
                            <span className="password_text">
                              {visiblePasswords[item.ID] ? item.Password : "••••••••"}
                            </span>
                            <button
                              type="button"
                              className="password_eye_btn"
                              onClick={() => togglePasswordVisibility(item.ID)}
                              title={visiblePasswords[item.ID] ? "Click to hide password" : "Click to view password"}
                            >
                              <i className={visiblePasswords[item.ID] ? "fa-solid fa-eye text-teal-600" : "fa-solid fa-eye-slash"}></i>
                            </button>
                          </div>
                        ) : (
                          <span style={{ color: "#94a3b8" }}>-</span>
                        )}
                      </td>
                      <td className="ledger_actions_cell">
                        <button
                          type="button"
                          className="ledger_btn_edit"
                          title="Edit User"
                          onClick={() => handleEdit(item)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                        <button
                          type="button"
                          className="ledger_btn_delete"
                          title="Delete User"
                          onClick={() => {
                            setDeleteId(item.ID);
                            setDeleteItemName(item.Name || item.UserName || item.User_Name || `User #${item.ID}`);
                            setDeleteModalOpen(true);
                          }}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Showing {firstIndex + 1} to{" "}
                {Math.min(lastIndex, filteredData.length)} of{" "}
                {filteredData.length} records
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && !error && filteredData.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Users Found</h6>
            <p>
              {searchQuery
                ? `No users matching "${searchQuery}"`
                : "No users available for the selected company."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        title="Delete User?"
        message="Are you sure you want to delete this user? Their account access will be revoked."
        itemName={deleteItemName}
        loading={isDeleting}
      />
    </div>
  );
};

export default UaerTabel;
